module.exports = __webpack_public_path__ + "img/canLikeOn.e9edd6fb.svg";